import React from 'react';
import { CTAButton } from './CTAButton';
export function BenefitSection() {
  return <section className="w-full bg-white py-8 px-4 border-t border-gray-200" data-id="element-36">
      <div className="max-w-2xl mx-auto text-center" data-id="element-37">
        <h2 className="text-3xl md:text-4xl font-black text-black leading-tight mb-6" data-id="element-38">
          Esto no cambia solo con el tiempo
        </h2>

        <p className="text-xl md:text-2xl font-bold text-gray-700 mb-6 leading-relaxed" data-id="element-39">
          Cambia cuando sabés qué hacer. Podés seguir probando sin saber… o
          empezar a acompañarlo con claridad desde hoy.
        </p>

        <CTAButton text="👉 QUIERO AYUDAR A MI HIJO SIN PELEAS" href="#compra" className="w-full" data-id="element-40" />
      </div>
    </section>;
}